import gql from 'fraql'
export const fragments = {
  product: gql`
    fragment _ on Product {
      idProduct: id
      name
      cost: price
      description
      idCategory
      maxDiscount
      isSale
      idBrand
      burger
      pizzaSize
      idOriginCat
      motivateSum
    }
  `,
  statusesOrder: gql`
    fragment _ on Order {
      statuses: statusOrdersByIdOrder {
        nodes {
          time
          stage: stageOrderByIdStageOrder {
            name,
            keyword
          },
          worker: workerByIdWorker {
            id,
            firstName,
            lastName,
            secondName,
          }
        }
      }
    }
  `,
  point: gql`
    fragment _ on RestPoint {
      id,
      address,
      targetTimeDeliveryIn,
      targetTimeDeliveryOut,
      targetSumDeliveryIn,
      targetSumDeliveryOut,
      clearTargetTimeDeliveryIn,
      clearTargetSumDeliveryIn,
    }
  `,
  orderInfo: gql`
    fragment _ on Order {
      id,
      comment,
      time,
      price: sum,
      pricePoints: sumPoints,
      payment,
      idDay,
      forDay,
      forTime,
      apartment,
      street,
      house,
      entrance,
      selectedPosition
      floor,
      office,
      discountValue,
      iikoId,
      change,
      mustAutoconfirm
      personNumber,
      fio,
      phone,
      kitchenComment,
      priority,
      priceDelivery,
      clientPriceDelivery,
      coords,
      timesPrinted,
      idWorkerOpened,
      idWorkerAccept,
      timeOpened,
      deletedComment
      idOrigin
      precision
      selectedPosition
      paymentChanged
      idDelivery
      typePayment:typePaymentByIdTypePayment {
        id,
        name,
        keyword
      },
      client: clientByIdClient {
        id
        name
        phone
        discount
        comment
        allowPoints
        brand: brandByIdBrand {
          id
          name
        }
      },
      brand: brandByIdBrand {
        id,
        name
      },
      point: restPointByIdRestPoint {
        id,
        address,
        targetTimeDeliveryIn,
        targetTimeDeliveryOut,
        targetSumDeliveryIn,
        targetSumDeliveryOut,
        clearTargetTimeDeliveryIn,
        clearTargetSumDeliveryIn,
      },
      typeDelivery: typeDeliveryByIdTypeDelivery {
        id,
        name,
        keyword
      },
      discountType: typeDiscountByIdTypeDiscount {
        id,
        name,
        keyword,
        comment
      },
      status: stageOrderByIdStage
      {
        id,
        name,
        keyword
      },
      courier: workerByIdCourier {
        id,
        firstName,
        lastName,
        secondName,
        phoneNumber,
      },
      statuses: statusOrdersByIdOrder {
        nodes {
          time
          stage: stageOrderByIdStageOrder {
            name,
            keyword
          }
        }
      },
      shift: shiftLogistianByIdShift {
        id,
        dateOpened,
        dateClosed
      }
    }
  `,
  orderInfoCallCenter: gql`
    fragment _ on Order {
      id,
      comment,
      time,
      price: sum,
      pricePoints: sumPoints,
      payment,
      idDay,
      idStage,
      forDay,
      forTime,
      apartment,
      city,
      street,
      house,
      entrance,
      floor,
      office,
      discountValue,
      change,
      mustAutoconfirm
      personNumber,
      fio,
      phone,
      kitchenComment,
      priceDelivery,
      clientPriceDelivery,
      coords,
      priority,
      idWorkerOpened,
      byMobile,
      deleted,
      ymapsDuration,
      ymapsDistance
      workerAccept: workerByIdWorkerAccept {
        id,
        firstName,
        lastName,
        secondName,
      },
      timeOpened,
      timeOpened
      idWorkerAccept
      deletedComment
      idOrigin
      precision
      selectedPosition
      settlement
      typePayment:typePaymentByIdTypePayment {
        id,
        name,
        keyword
      },
      client: clientByIdClient {
        id
        name
        phone
        discount
        comment
        allowPoints
        onlyOnlinePayment
        brand: brandByIdBrand {
          id
          name
        }
      },
      brand: brandByIdBrand {
        id,
        name
      },
      point: restPointByIdRestPoint {
        id,
        address
      },
      typeDelivery: typeDeliveryByIdTypeDelivery {
        id,
        name,
        keyword
      },
      discountType: typeDiscountByIdTypeDiscount {
        id,
        name,
        keyword,
        comment
      },
      status: stageOrderByIdStage
      {
        id,
        name,
        keyword,
        sort
      },
      courier: workerByIdCourier {
        id,
        firstName,
        lastName,
        secondName,
        phoneNumber,
      },
      workshop: taskWorkshopsByIdOrder {
        nodes {
          id,
          idTypeWorkshop,
          stageWorkshop,
          timeCreation,
          stage: stageWorkshopByStageWorkshopAndIdTypeWorkshop {
            name,
            keyword,
            workshop: typeWorkshopByIdType {
              name,
              keyword
            }
          }
        }
      }
    }
  `,
  orderProducts: gql`
    fragment _ on Order {
      prods: productOrdersByIdOrder {
        nodes {
          id,
          idProduct,
          name,
          count,
          cost: price,
          pricePoints,
          group,
          deleted,
          smallSize,
          promocodeItem,
          category: categoryByIdCategory {
            idBrand
          }
          prod: productByIdProduct {
            idCategory,
            maxDiscount,
            description,
            burger
            isSale
            pizzaSize,
            idOriginCat
          }
        }
      }
    }
  `,
  coldWorkshopTasks: gql`
    fragment _ on TaskWorkshop {
      id,
      order: orderByIdOrder {
        id,
        comment,
        idDay,
        kitchenComment,
        forTime
        typeDelivery: typeDeliveryByIdTypeDelivery {
          keyword
        }
        priority
        brandName
        coldProducts {
          nodes {
            id,
            name,
            idCategory,
            count,
            group,
            deleted,
            product: productByIdProduct {
              description,
              components
            }
          }
        }
      },
      timeCreation,
      stageWorkshop
    }
  `,
  hotWorkshopTasks: gql`
    fragment _ on TaskWorkshop {
      id,
      order: orderByIdOrder {
        id,
        comment,
        idDay,
        kitchenComment
        forTime
        typeDelivery: typeDeliveryByIdTypeDelivery {
          keyword
        }
        priority
        brandName
        hotProducts {
          nodes {
            id,
            name,
            idCategory,
            count,
            group,
            deleted,
            product: productByIdProduct {
              components
              composition
            }
          }
        }
      },
      timeCreation,
      stageWorkshop
    }
  `,
  pizzaTasks: gql`
    fragment _ on TaskWorkshop {
      id,
      idOrder,
      order: orderByIdOrder {
        id,
        idDay
        kitchenComment
        forTime
        typeDelivery: typeDeliveryByIdTypeDelivery {
          keyword
        }
        priority
        brandName
      }
      productOrder: productOrderByIdProductOrder {
        id,
        name,
        idCategory,
        count,
        group,
        deleted,
        smallSize,
        product: productByIdProduct {
          composition,
          numberOfPizza
        }
      }
      timeCreation,
      stageWorkshop
    }
  `,
  pizzaWorkshopTasks: gql`
    fragment _ on TaskWorkshop {
      id,
      order: orderByIdOrder {
        id,
        comment,
        idDay,
        forTime
        kitchenComment
        typeDelivery: typeDeliveryByIdTypeDelivery {
          keyword
        }
        priority
        brandName
        pizzaProducts {
          nodes {
            id,
            name,
            idCategory,
            count,
            group,
            product: productByIdProduct {
              composition
            }
          }
        }
      },
      timeCreation,
      stageWorkshop
    }
  `,
  paymentInfo: gql`
    fragment _ on Order {
      paymentInfo {
        id,
        cash,
        cardOnline,
        cardInPlace,
        sberbank,
        paymentLink,
        payed
      }
    }
  `,
  paymentOnlyInfo: gql`
    fragment _ on Order {
      paymentOnlyInfo: paymentInfo {
        cash,
        cardOnline,
        cardInPlace,
        sberbank,
        paymentLink,
      }
    }
  `,
  promocodeInfo: gql`
    fragment _ on Promocode {
      id
      promocode
      idBrand
      idTypeDiscount
      sumDiscount
      description
      active
      title
      result
      rules
    }
  `,
  callCenterOrdersItem: gql`
    fragment _ on Order {
      apartment
      byMobile
      change
      city
      client: clientByIdClient {
          id
          name
          phone
      }
      comment
      courier: workerByIdCourier {
          id
          firstName
          lastName
          secondName
      }
      entrance
      house
      fio
      forDay
      forTime
      floor
      id
      idDay
      idOrigin
      idRestPoint
      idStage
      idTypeDelivery
      idTypePayment
      idWorkerOpened
      mustAutoconfirm
      office
      payment
      personNumber
      phone
      price: sum
      pricePoints: sumPoints
      priority
      selectedPosition
      settlement
      street
      time
      workerAccept: workerByIdWorkerAccept {
          id
          firstName
          lastName
          secondName
      }
      workshop: taskWorkshopsByIdOrder {
          nodes {
              idTypeWorkshop
              stageWorkshop
              id
          }
      }
    }
  `,
  collectorOrdersItem: gql`
    fragment _ on Order {
      city
      street
      house
      client: clientByIdClient {
        name
        phone
      }
      comment
      courier: workerByIdCourier {
        id
        lastName
        firstName
        secondName
      }
      fio
      forDay
      forTime
      id
      idDay
      idStage
      phone
      point: restPointByIdRestPoint {
        id
        targetTimeDeliveryIn
        address
      }
      price: sum
      pricePoints: sumPoints
      priority
      personNumber
      settlement
      statuses: statusOrdersByIdOrder {
        nodes {
          time
          idStageOrder
        }
      }
      time
      timesPrinted
      typeDelivery: typeDeliveryByIdTypeDelivery {
        keyword
      }
      workerAccept: workerByIdWorkerAccept {
        id
        firstName
        lastName
        secondName
      }
    }
  `,
  logistycOrdersItem: gql`
    fragment _ on Order {
      apartment
      office
      city
      street
      house
      entrance
      floor
      coords
      client: clientByIdClient {
          name
          phone
      }
      comment
      courier: workerByIdCourier {
          id
          lastName
          firstName
          secondName
      }
      fio
      forDay
      forTime
      id
      idDay
      idStage
      phone
      point: restPointByIdRestPoint {
          id
          targetTimeDeliveryIn
          address
      }
      price: sum
      pricePoints: sumPoints
      priority
      prods: productOrdersByIdOrder {
        nodes {
          name
        }
      }
      settlement
      stageKeyword
      statuses: statusOrdersByIdOrder {
          nodes {
              time
              worker: workerByIdWorker {
                  id
              }
              stage: stageOrderByIdStageOrder {
                  name
                  keyword
              }
          }
      }
      time
      typeDelivery: typeDeliveryByIdTypeDelivery {
        keyword
      }
      workerAccept: workerByIdWorkerAccept {
          id
          firstName
          lastName
          secondName
      }
    }
  `,
  logistycDeliverysOrderItem: gql`
    fragment _ on Order {
      apartment
      office
      city
      street
      house
      entrance
      floor
      coords
      client: clientByIdClient {
          name
          phone
      }
      comment
      courier: workerByIdCourier {
          id
          lastName
          firstName
          secondName
      }
      fio
      forDay
      forTime
      id
      idDay
      idStage
      phone
      point: restPointByIdRestPoint {
          id
          targetTimeDeliveryIn
          address
      }
      price: sum
      pricePoints: sumPoints
      priority
      prods: productOrdersByIdOrder {
        nodes {
          name
        }
      }
      settlement
      stageKeyword
      statuses: statusOrdersByIdOrder {
          nodes {
              time
              stage: stageOrderByIdStageOrder {
                  name
                  keyword
              }
          }
      }
      time
      typeDelivery: typeDeliveryByIdTypeDelivery {
        keyword
      }
    }
  `,
  courierOrdersItem: gql`
    fragment _ on Order {
      apartment
      office
      city
      street
      house
      entrance
      floor
      change
      coords
      client: clientByIdClient {
          name
          phone
      }
      comment
      courier: workerByIdCourier {
          id
          lastName
          firstName
          secondName
      }
      fio
      forDay
      forTime
      id
      idDay
      idStage
      point: restPointByIdRestPoint {
          id
          targetTimeDeliveryIn
          address
      }
      price: sum
      pricePoints: sumPoints
      priority
      phone
      prods: productOrdersByIdOrder {
        nodes {
          name
        }
      }
      shift: shiftLogistianByIdShift {
        dateClosed
      }
      selectedPosition
      settlement
      stageKeyword
      status: stageOrderByIdStage {
          keyword
      }
      statuses: statusOrdersByIdOrder {
          nodes {
              time
              worker: workerByIdWorker {
                  id
              }
              stage: stageOrderByIdStageOrder {
                  name
                  keyword
              }
          }
      }
      time
      typeDelivery: typeDeliveryByIdTypeDelivery {
        keyword
      }
    }
  `
}



// WEBPACK FOOTER //
// ./src/constants/fragments.js